/**
 * Utility function to get the current page from the URL.
 * It extracts the last segment of the pathname, or returns "home" if the pathname is "/".
 * The first part of the pathname is ignored, as it is assumed to be the language code (e.g., "/de/agent" -> "agent").
 */
export const getCurrentPage = () => {
  const segments = window.location.pathname.split("/").filter(Boolean);
  return segments.length > 1 ? segments[segments.length - 1] : "";
};
